<template>
    <i
        class="SbsFaIcon"
        :class="iconClasses"
        v-bind="$attrs"></i>
</template>

<script>
import { AllIconGroups, ICON_ANIMATIONS, ICON_GROUPS } from './constants';

/**
 * Компонент для иконок FontAwesome
 */
export default {
    name: 'SbsFaIcon',
    computed: {
        iconClasses() {
            const classes = [];

            if (this.animation) classes.push(`fa-${this.animation}`);

            if (this.iconGroup) classes.push(`fa-${this.iconGroup}`);

            if (this.iconName) classes.push(`fa-${this.iconName}`);

            if (this.fixedWidth) classes.push('fa-fw');

            return classes;
        },
    },
    props: {
        /**
         * Название класса, отвечающего за анимацию иконки
         */
        animation: {
            type: String,
            default: '',
            validator: value => !value || ICON_ANIMATIONS.includes(value),
        },
        /**
         * Включение фиксированной ширины для любой иконки – `1.25em`
         */
        fixedWidth: {
            type: Boolean,
            default: false,
        },
        /**
         * Стиль (группа) иконки
         */
        iconGroup: {
            type: String,
            default: AllIconGroups.REGULAR,
            validator: value => ICON_GROUPS.includes(value),
        },
        /**
         * Название иконки из FontAwesome.
         * Список всех иконок можно посмотреть [здесь](https://fontawesome.com/v6/icons)
         */
        iconName: {
            type: String,
            required: true,
        },
    },
};
</script>

<style lang="scss">
.SbsFaIcon {
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    line-height: 1;
}
</style>
